<template>
  <v-dialog :model-value="dialogActive" max-width="760px" persistent scrollable>
    <v-card class="dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">{{getDialogTitle()}}</span>
      </v-card-title>

      <v-card-text>
        <v-alert v-if="saveError" type="error" variant="tonal" class="mb-4">{{ saveError }}</v-alert>
        <v-form ref="form" v-model="valid" validate-on="lazy" :disabled="saving" @submit.prevent="save">
          <v-text-field
            label="Nombre del Lugar"
            v-model="editedItem.name"
            :rules="[rules.requiredFieldRule]">
          </v-text-field>
          <v-select
            class="mb-4"
            label="Tipos de lugar"
            v-model="editedItem.typeIds"
            :items="getLocationTypes"
            item-title="name"
            item-value="id"
            multiple
            chips
            clearable
            hint="Puede elegir ninguno, uno o varios tipos."
            persistent-hint/>
          <v-select
            label="Pais"
            v-model="editedItem.country"
            :items="countries"
            :rules="[rules.requiredFieldRule]"
            variant="outlined"/>
          <v-select
            label="Provincia / Estado / Departamento"
            v-model="editedItem.province"
            :items="availableProvinces"
            :disabled="!editedItem.country"
            :rules="[rules.requiredFieldRule]"
            variant="outlined"/>
          <v-text-field label="Ciudad" v-model="editedItem.city" variant="outlined"/>
          <v-text-field
            label="Direccion"
            v-model="editedItem.address"
            :rules="[rules.requiredFieldRule]"
            variant="outlined"/>
          <v-text-field
            label="Codigo Postal"
            v-model="editedItem.postalCode"
            :rules="[rules.requiredFieldRule]"
            variant="outlined"/>
          <v-textarea
            label="Observaciones"
            v-model="editedItem.obs"
            auto-grow
            box
            rows="3"/>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" variant="text" min-height="48" :disabled="saving" @click="close()">Cancelar</v-btn>
        <v-btn v-if="canSave" color="primary" min-height="48" :loading="saving" @click="save()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import { countries, provincesByCountry } from '@/services/LocationOptions'
import CatalogEditor from '../Common/CatalogEditor'
export default {
  name: 'AddEditLocationForm',
  mixins: [CatalogEditor],
  props: {
    formTitle: String,
    presetType: { type: String, default: '' }
  },
  data: () => ({
    valid: true,
    catalogPermission: 'catalog.locations',
    catalogModule: 'locationModule',
    catalogSaveAction: 'saveLocation',
    countries,
    provincesByCountry,
    pswrdsNotMatch: false,
    pswdCheckbox: false,
    rules: {
      requiredFieldRule: v => !!v || 'Campo requerido',
      min: value => {
        if (value) {
          return (value.length >= 6 || '6 caracteres minimo')
        }
        return false
      }
    },
    editedItem: {
      id: -1,
      typeIds: [],
      name: '',
      city: '',
      province: '',
      address: '',
      country: 'Argentina',
      postalCode: '',
      obs: ''
    },
    defaultItem: {
      id: -1,
      typeIds: [],
      name: '',
      city: '',
      province: '',
      address: '',
      country: 'Argentina',
      postalCode: '',
      obs: ''
    }
  }),
  computed: {
    ...mapGetters('locationModule', ['isDialogActived', 'getSelectedItem', 'getLocationTypes']),
    currentItem: function () {
      return this.$store.getters['locationModule/getSelectedItem']
    },
    itemId: function () {
      return this.editedItem.id
    },
    availableProvinces () {
      return this.provincesByCountry[this.editedItem.country] || []
    }
  },

  created () {
    this.$store.dispatch('locationModule/getLocationTypes').then(() => {
      if (this.editedItem.id <= 0 && this.presetType && !this.editedItem.typeIds.length) this.applyPresetType()
    }).catch(() => { this.saveError = 'No se pudieron cargar los tipos de lugar. Cierre y vuelva a abrir el formulario.' })
  },

  watch: {
    'editedItem.country': function (country, previousCountry) {
      if (country !== previousCountry && !this.availableProvinces.includes(this.editedItem.province)) {
        this.editedItem.province = ''
      }
    }
  },

  methods: {

    initializeEditor () {
      const item = this.modelValue === undefined && this.currentItem.id > 0 ? this.currentItem : {}
      this.editedItem = { ...this.defaultItem, ...item,
        typeIds: [...(item.typeIds || (item.types || []).map(type => type.id))] }
      if (this.editedItem.id <= 0) this.applyPresetType()
    },
    applyPresetType () {
      const type = this.getLocationTypes.find(type => type.code === this.presetType)
      if (type) this.editedItem.typeIds = [type.id]
    },

    getDialogTitle () {
      let dialogTitle
      if (this.editedItem.id > 0) {
        dialogTitle = `Editando Lugar ${this.editedItem.name}`
      } else {
        dialogTitle = 'Agregar Lugar'
      }
      return dialogTitle
    }
  }
}
</script>
